import React from 'react';
import { connect } from 'react-redux';
import { Show, SimpleShowLayout } from "components/detail";
import { TextField, ChoiceDisplayField, ImageField } from "components/field";
import * as urls from "./urls";
import {
  DualScreenAdTargetUsersMap,
  DualScreenAdStatusMap,
  DualScreenAdTypeMap,
  DualScreenAdTargetTypeSelect,
  DualScreenAdResourceName,
} from "./utils";

function DownloadLink({ record = {} }) {
  if (record.target_type !== DualScreenAdTargetTypeSelect) return null;
  const content = (
    <a target="_blank" rel="noopener noreferrer" href={record.shop_id_list_file_url}>
      shop_id.csv
    </a>
  );
  return (
    <TextField source="content" record={{ content }} label="Shop Ids File" />
  );
}

export const DualScreenAdDetailBase = (props={}) => {

  const { match={}, data={} } = props;
  const { params={} } = match;
  const { id } = params;
  const record = data[id] || {};

  return (
    <Show detailBackendPath={urls.dualScreenAdDetailBackendPath} {...props}>
      <SimpleShowLayout>
        <ChoiceDisplayField
          source="ad_type"
          label="TYPE"
          choiceName={DualScreenAdTypeMap}
        />
        <TextField source="ad_name" label="NAME" />
        <ChoiceDisplayField
          source="target_type"
          label="TARGET USERS"
          choiceName={DualScreenAdTargetUsersMap}
        />
        {
          record.target_type === DualScreenAdTargetTypeSelect ? (<DownloadLink 
            addLabel={true} 
            source="shop_id_list_file_url"
            label="Shop Ids File"
          />) : null
        }
        <TextField source="priority" label="PRIORITY" />
        <TextField source="valid_from" label="VALID From" />
        <TextField source="valid_to" label="VALID To" />
        <TextField source="publish_status" label="PUBLISH STATUS" />
        <ChoiceDisplayField
          source="ad_status"
          label="STATUS"
          choiceName={DualScreenAdStatusMap}
        />
        <ImageField addLabel={true} source="image_url" label="Image" />
      </SimpleShowLayout>
    </Show>
  );
};


const DualScreenAdDetail = connect(
  (state) => {
    return {
      data: state.admin[DualScreenAdResourceName].data,
    }
  },
  {},
)(DualScreenAdDetailBase);

export default DualScreenAdDetail



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/DualScreenAdDetail.js